import React from 'react';
import { Heart, ShieldCheck, Sparkles } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const NGODiscountPage = () => {
  const config = {
    badge: "NGO Compassion Program",
    headline: "50% NGO",
    headlineItalic: "Discount.",
    subtext: "Committed to compassionate care for all animals — Dr. Suresh Pet Care offers a 50% discount on all services for verified NGO-rescued animals.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "NGO Discount at Dr. Suresh Pet Care — Compassionate Veterinary Care",
    stats: [
      { value: 500, suffix: '+', label: 'NGO Animals Treated' },
      { value: 50, suffix: '%', label: 'Guaranteed Discount' },
      { value: 20, suffix: '+', label: 'Partner NGOs' },
      { value: 24, suffix: '/7', label: 'Emergency For All' },
    ],
    services: [
      {
        title: "50% Consultation Discount",
        icon: <Heart size={28} />,
        desc: "Half-price consultation fees for all NGO-verified animals including strays, rescues, and surrendered pets.",
        specs: ["Emergency Consult", "Wellness Check", "Specialist Referral", "Follow-up Visits"],
        color: "from-rose-500/10 to-primary/10"
      },
      {
        title: "Discounted Surgeries",
        icon: <ShieldCheck size={28} />,
        desc: "50% reduction on all surgical procedures for rescued and NGO-sponsored animals needing intervention.",
        specs: ["Sterilization", "Fracture Repair", "Mass Removal", "Emergency Surgery"],
        color: "from-primary/10 to-green-500/10"
      },
      {
        title: "NGO Partnership Program",
        icon: <Sparkles size={28} />,
        desc: "Formal partnerships with animal welfare NGOs for streamlined, priority access to veterinary care.",
        specs: ["Priority Scheduling", "Dedicated Coordinator", "Medical History", "NGO Billing"],
        color: "from-amber-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our NGO",
    sectionItalic: "Program.",
    warningTitle: "Mission",
    warningItalic: "Statement.",
    warningText: "Every animal deserves compassionate, quality veterinary care, regardless of their background or owner's financial situation.",
    warnings: [
      { name: "Verification Required", desc: "A valid NGO registration document is required at the time of visit.", icon: "📋" },
      { name: "All Animals Welcome", desc: "Dogs, cats, birds, and other rescued animals all qualify for the discount.", icon: "🐾" },
      { name: "Emergency Priority", desc: "Rescued animals in critical condition receive priority emergency access.", icon: "🚨" },
      { name: "Partnership Fast-Track", desc: "Registered partner NGOs receive streamlined scheduling and billing options.", icon: "🤝" },
    ],
    ctaBadge: "Compassion Initiative",
    ctaTitle: "The NGO",
    ctaItalic: "Partnership.",
    ctaText: "Contact us to register your NGO or to bring a rescued animal for care. Dr. T Suresh Babu is deeply committed to the welfare of all animals in Hyderabad.",
    ctaBtn: "Register Your NGO",
    seoText: "50% veterinary discount for NGOs in Hyderabad. Animal rescue veterinary care at Dr. Suresh Pet Care. Compassionate care for rescued dogs and cats.",
    glowColor: "rose-500"
  };

  return (
    <>
      <SEO 
        title="50% NGO Discount — Veterinary Care"
        description="Dr. Suresh Pet Care provides a 50% discount on veterinary services for NGO-rescued animals in Hyderabad. Compassionate care for all animals."
        canonical="/ngo-discount"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default NGODiscountPage;
